// 教育经历
import React from 'react';
import {
  Form, Input, Selector,
} from '@roo/roo';
import { get } from 'lodash';
import {
  requiredRule,
  getRuleLen,
  emailRule,
  phoneRule,
} from '@utils/rules';
import { positionalTitleOptions } from '@utils/positionTitle';
import useTrimOnBlur from '@hooks/useInputTrim';
import Area from './area';
import { FieldList } from '../../_components/FieldList';

const Field = Form.field;

const eduInfoObj = {
  startTime: '', // 开始时间
  endTime: '', // 结束时间
  collegeName: '', // 学校名称
  major: '', // 专业
  degreeType: '', // 学位
};

const Authority = (props) => {
  const { setFieldValue } = props;
  const handlePositionBlur = useTrimOnBlur(setFieldValue, 'position');

  return (
    <FieldList
      {...props}
      hid
      name="authScientist"
      maxCount={2}
      minCount={0}
      plusText="添加专家"
      iniData={eduInfoObj}
      itemClassName="form-patch bc"
    >
      <Field
        required
        hid
        label="专家姓名"
        name="authName"
        rule={{ ...requiredRule }}
        as={<Input maxLength={50} placeholder="请输入该专家的姓名" />}
      />
      <Field
        required
        hid
        rule={{ ...requiredRule }}
        label="单位名称"
        name="authCompany"
        as={<Input maxLength={100} placeholder="请输入该专家所在的单位" />}
      />
      <Field
        required
        rule={getRuleLen(50, true)}
        label="职务"
        name="position"
        as={<Input maxLength={50} placeholder="请输入该专家的职务" onBlur={handlePositionBlur} />}
      />
      <Field
        required
        label="职称"
        name="positionalTitle"
        rule={requiredRule}
        as={
          <Selector options={positionalTitleOptions} placeholder="请选择该专家的职称" />
        }
      />
      <Field
        hid
        required
        rule={phoneRule}
        label="手机号"
        name="phone"
        as={<Input maxLength={50} placeholder="请输入该专家的手机号" />}
      />
      <Field
        hid
        required
        rule={emailRule}
        label="邮箱"
        name="email"
        as={<Input maxLength={50} placeholder="请输入该专家的联系邮箱" />}
      />
      <Field
        required
        label="学科"
        name="studyArea"
        rule={{
          validator: (rule, value1, callback) => {
            const {
              fullField,
            } = rule;
            const value = (get(props, `values.${fullField}`) || []).filter(Boolean);
            const type = get(props, `values.${fullField}`.replace('studyArea', 'studyAreaType'));
            if (type === value.length && [1, 2].includes(type)) {
              return callback();
            }
            callback('请选择该专家所属学科领域');
          },
        }}
      >
        {(params) => {
          const {
            item, validateField, idx,
          } = params;
          return (
            <Area
              disabled={props.disabled}
              validateField={validateField}
              setFieldValue={setFieldValue}
              type={item.studyAreaType}
              typeKey={`authScientist.${idx}.studyAreaType`}
              studyAreaPath={item.studyAreaPath}
              studyAreaKey={`authScientist.${idx}.studyArea`}
              tip="请选择该专家所属学科领域"
            />
          );
        }}
      </Field>
      <Field
        required
        rule={getRuleLen(100, true)}
        label="主要研究方向"
        name="researchDirection"
        as={<Input maxLength={100} placeholder="请输入该专家的主要研究方向" />}
      />
    </FieldList>
  );
};

export default Authority;
